import { BrokerRoles, IOpusUser } from "platform-client/types"

/** Only these roles can work across several branches (offices) of a brokerage */
export const multiBranchRoles: string[] = [
  BrokerRoles.AccountManager,
  BrokerRoles.User
]

/**
 * Whether the user can be added to another branch - eg a Broker Administrator manages the brokerage
 * from its top level company, so can't be
 */
export const canWorkInSeveralBranches = (
  user: Pick<IOpusUser, "roles"> | undefined
): boolean =>
  (user?.roles || []).some((role) =>
    multiBranchRoles.some(
      (name) => name.toLowerCase() === role.name?.toLowerCase()
    )
  )
